export default "__VITE_ASSET__CqCSCIPf__"